export default {

    namespaced:true,

    state: {

    },// state

    getters: {

        getAll: (state,getters,rootState,rootGetters) => {
            return rootGetters.getAll('clients')
            if( !rootGetters.firebase_arrays.clients ) return []
            return rootGetters.firebase_arrays.clients
        },

        //getOne: (state,getters,rootState,rootGetters) => (key) =>  { for( let item of getters.getAll ) if( item.key === key ) return item },
        getOne: (state,getters,rootState,rootGetters) => (key) =>  { return rootGetters.getOne('client',key) },

        getClient: (state,getters,rootState,rootGetters) => (client_key) => 
        {
            return rootGetters.getOne('client',client_key)
            if( !client_key ) return
            if( !rootState.firebase ) return
            if( !rootState.firebase.clients ) return
            var c = rootState.firebase.clients[client_key]
            return c
        },
        
        getClientByProjectKey: (state,getters,rootState,rootGetters) => (project_key) => 
        {
            var p = rootGetters['projects/getProject'](project_key)
            if( !p || !p.client_key ) return
            return getters.getClient(p.client_key)
        },

        get_client_projects: (state,getters,rootState,rootGetters) => (client_key) => 
        {
            var projects = rootGetters['projects/getFiltered']({
                client_key: client_key,
            })
            return projects
        },


        get_total_earning: (state,getters,rootState,rootGetters) => (client) => 
        {
            
            var total = 0
            var client_key = client.key || client['.key']
            var projects = getters.get_client_projects(client_key)

            for( let project of projects ) rootGetters['projects/get_payable_amount'](project)

            return total
        },


        
    },// getters

}


// WEBPACK FOOTER //
// ./src/store/modules/clients.js